import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { ProSidebar, Menu, MenuItem, SubMenu, SidebarHeader, SidebarFooter, SidebarContent } from 'react-pro-sidebar';
import { FaTachometerAlt, FaGem, FaList, FaGithub, FaRegLaughWink, FaHeart } from 'react-icons/fa';
import Link from "next/link";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRouter } from "next/router";
import { getBooks, logOut } from "../../../api/requests";
import useTranslation from "next-translate/useTranslation"; // import sidebarBg from './assets/bg1.jpg';

var Aside = function Aside(_ref) {
  var image = _ref.image,
      rtl = _ref.rtl,
      handleToggleSidebar = _ref.handleToggleSidebar,
      toggled = _ref.toggled,
      collapsed = _ref.collapsed,
      classes = _ref.classes;
  var router = useRouter();

  var _useState = useState(null),
      user = _useState[0],
      setUser = _useState[1];

  var _useTranslation = useTranslation(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var isRTL = lang === 'farsi';
  useEffect(function () {
    var Username = localStorage.getItem('Username');
    var Counter = localStorage.getItem('Counter');
    var token = localStorage.getItem('token');

    if (Username && token) {
      setUser({
        Username: Username,
        token: token,
        Counter: Counter
      });
    }
  }, []);

  var handleLogout = function handleLogout(e) {
    e.preventDefault();
    var token = localStorage.getItem('token');
    logOut(token).then(function (res) {
      setUser(null);

      if (router.pathname === '/') {
        window.location.reload(false);
      } else {
        router.push('/');
      }
    })["catch"](function (err) {
      return console.log("log out error", {
        err: err
      });
    });
  };

  var startClicked = function startClicked() {
    localStorage.setItem('homeFirstTimeUser', 1);
  };

  return /*#__PURE__*/_jsxs(ProSidebar // image={image ? sidebarBg : false}
  , {
    image: false,
    rtl: rtl,
    collapsed: collapsed,
    toggled: toggled,
    breakPoint: "md",
    onToggle: handleToggleSidebar,
    className: classes && classes.sidebar,
    children: [/*#__PURE__*/_jsx(SidebarContent, {
      style: {
        fontFamily: isRTL ? 'Yekan' : 'Helvetica'
      },
      children: /*#__PURE__*/_jsxs(Menu, {
        children: [/*#__PURE__*/_jsxs("span", {
          className: "d-flex",
          children: [/*#__PURE__*/_jsx(MenuItem, {
            children: /*#__PURE__*/_jsx(Link, {
              href: "/",
              children: /*#__PURE__*/_jsx("a", {
                children: t('navbar:home')
              })
            })
          }), /*#__PURE__*/_jsx("button", {
            className: "btn text-white",
            onClick: function onClick() {
              return handleToggleSidebar(!toggled);
            },
            children: /*#__PURE__*/_jsx(FontAwesomeIcon, {
              icon: faTimes,
              style: {
                width: "16px",
                height: "16px"
              }
            })
          })]
        }), /*#__PURE__*/_jsx(MenuItem, {
          children: /*#__PURE__*/_jsx(Link, {
            href: "/start",
            children: /*#__PURE__*/_jsx("a", {
              onClick: function onClick() {
                return startClicked();
              },
              children: t('navbar:start')
            })
          })
        }), /*#__PURE__*/_jsx(MenuItem, {
          children: /*#__PURE__*/_jsx(Link, {
            href: "/learn",
            children: /*#__PURE__*/_jsx("a", {
              children: t('navbar:learn')
            })
          })
        }), /*#__PURE__*/_jsx(MenuItem, {
          children: /*#__PURE__*/_jsx(Link, {
            href: "/wow-stories",
            children: /*#__PURE__*/_jsx("a", {
              children: t('navbar:wowStories')
            })
          })
        }), /*#__PURE__*/_jsx(MenuItem, {
          children: /*#__PURE__*/_jsx("a", {
            href: "https://wowmagazine.ir/",
            target: "_blank",
            children: t('navbar:wowMagazine')
          })
        }), /*#__PURE__*/_jsx(MenuItem, {
          children: /*#__PURE__*/_jsx(Link, {
            href: "/top-users",
            children: /*#__PURE__*/_jsx("a", {
              children: t('navbar:topUsers')
            })
          })
        }), /*#__PURE__*/_jsx(MenuItem, {
          children: /*#__PURE__*/_jsx(Link, {
            href: "/about-us",
            children: /*#__PURE__*/_jsx("a", {
              children: t('navbar:aboutUs')
            })
          })
        }), /*#__PURE__*/_jsx(MenuItem, {
          children: /*#__PURE__*/_jsx(Link, {
            href: "/score",
            children: /*#__PURE__*/_jsx("a", {
              children: t('navbar:rules')
            })
          })
        }), /*#__PURE__*/_jsx(MenuItem, {
          children: /*#__PURE__*/_jsx(Link, {
            href: "/contact-us",
            children: /*#__PURE__*/_jsx("a", {
              children: t('navbar:contactUs')
            })
          })
        }), /*#__PURE__*/_jsx(MenuItem, {
          children: user && user.token && /*#__PURE__*/_jsx(Link, {
            href: user ? {
              pathname: "/profile/".concat(user.Counter),
              // query: {name: user.firstName + " " + user.lastName},
              query: {
                name: user.Username
              }
            } : '',
            children: /*#__PURE__*/_jsx("a", {
              children: t('navbar:profile')
            })
          })
        }), /*#__PURE__*/_jsx(MenuItem, {
          children: user === null && /*#__PURE__*/_jsx(Link, {
            href: {
              pathname: '/verifyPhone',
              query: {
                redirect: 'home'
              }
            },
            children: /*#__PURE__*/_jsx("a", {
              children: t('navbar:login')
            })
          })
        }), /*#__PURE__*/_jsx(MenuItem, {
          children: user === null && /*#__PURE__*/_jsx(Link, {
            href: {
              pathname: '/verifyPhone',
              query: {
                redirect: 'home'
              }
            },
            children: /*#__PURE__*/_jsx("a", {
              children: t('navbar:register')
            })
          })
        })]
      })
    }), /*#__PURE__*/_jsx(SidebarFooter, {
      style: {
        textAlign: 'center'
      },
      children: /*#__PURE__*/_jsx("div", {
        className: "sidebar-btn-wrapper",
        style: {
          padding: '20px 24px'
        },
        children: user && user.token && /*#__PURE__*/_jsx("p", {
          className: "sidebar-footer-text",
          style: {
            cursor: 'pointer',
            fontFamily: isRTL ? 'Yekan' : 'Helvetica'
          },
          onClick: handleLogout,
          children: t('navbar:log-out')
        })
      })
    })]
  });
};

export default Aside;